import React, { Component } from "react";

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="936.268"
      height="604"
      data-name="Layer 1"
      viewBox="0 0 936.268 604"
    >
      <path
        fill="#ccc"
        d="M441 95h-88a5 5 0 010-10h88a5 5 0 010 10zM509 130H353a5 5 0 010-10h156a5 5 0 010 10zM470 165H353a5 5 0 010-10h117a5 5 0 010 10zM509 200H353a5 5 0 010-10h156a5 5 0 010 10z"
      ></path>
      <circle cx="149.304" cy="140.545" r="89.47" fill="#536dfe"></circle>
      <path fill="#3f3d56" d="M154.304 56.124h-10v-10h10zm-8-2h6v-6h-6z"></path>
      <path fill="#3f3d56" d="M152.539 50.124H205.539V52.124H152.539z"></path>
      <circle cx="205.539" cy="51.124" r="2.083" fill="#3f3d56"></circle>
      <path fill="#3f3d56" d="M93.539 50.124H145.539V52.124H93.539z"></path>
      <circle cx="93.539" cy="51.124" r="2.083" fill="#3f3d56"></circle>
      <path fill="#3f3d56" d="M243.54 145.31h-10v-10h10zm-8-2h6v-6h-6z"></path>
      <path fill="#3f3d56" d="M237.539 144.545H239.539V196.545H237.539z"></path>
      <circle cx="238.539" cy="196.545" r="2.083" fill="#3f3d56"></circle>
      <path
        fill="#3f3d56"
        d="M237.539 84.545H239.539V136.54500000000002H237.539z"
      ></path>
      <circle cx="238.539" cy="84.545" r="2.083" fill="#3f3d56"></circle>
      <path fill="#3f3d56" d="M64.54 145.31h-10v-10h10zm-8-2h6v-6h-6z"></path>
      <path fill="#3f3d56" d="M58.539 144.545H60.539V196.545H58.539z"></path>
      <circle cx="59.539" cy="196.545" r="2.083" fill="#3f3d56"></circle>
      <path
        fill="#3f3d56"
        d="M58.539 82.545H60.539V136.54500000000002H58.539z"
      ></path>
      <circle cx="59.539" cy="84.545" r="2.083" fill="#3f3d56"></circle>
      <path
        fill="#3f3d56"
        d="M154.304 235.124h-10v-10h10zm-8-2h6v-6h-6z"
      ></path>
      <path fill="#3f3d56" d="M153.539 229.124H206.539V231.124H153.539z"></path>
      <circle cx="205.539" cy="230.124" r="2.083" fill="#3f3d56"></circle>
      <path fill="#3f3d56" d="M93.539 229.124H145.539V231.124H93.539z"></path>
      <circle cx="93.539" cy="230.124" r="2.083" fill="#3f3d56"></circle>
      <path
        fill="#3f3d56"
        d="M562 305H17a17.02 17.02 0 01-17-17V17A17.02 17.02 0 0117 0h545a17.02 17.02 0 0117 17v271a17.02 17.02 0 01-17 17zM17 2A15.017 15.017 0 002 17v271a15.017 15.017 0 0015 15h545a15.017 15.017 0 0015-15V17a15.017 15.017 0 00-15-15z"
      ></path>
      <circle cx="330" cy="90" r="5" fill="#ccc"></circle>
      <circle cx="330" cy="125" r="5" fill="#ccc"></circle>
      <circle cx="330" cy="160" r="5" fill="#ccc"></circle>
      <circle cx="330" cy="195" r="5" fill="#ccc"></circle>
      <path
        fill="#ff6584"
        d="M438.058 239.028H407.52a3.765 3.765 0 01-3.761-3.761v-36.036a3.765 3.765 0 013.76-3.76h30.538a3.765 3.765 0 013.76 3.76v36.036a3.765 3.765 0 01-3.76 3.76z"
      ></path>
      <path
        fill="#f2f2f2"
        d="M756.806 602.55l-3.39.83c1.53.22 3.06.43 4.59.62h56.54q6.36-.81 12.65-2a197.136 197.136 0 0070.96-28.11c13.27-8.63 25.92-19.24 32.79-33.49 9.33-19.35 6.07-43.85-7.25-60.7a60.772 60.772 0 00-17.59-15c-1.01-.58-2.03-1.13-3.07-1.65a66.06 66.06 0 00-36.49-6.68c-21.35 2.33-41.05 15.37-52.42 33.59-12.57 20.12-14.98 44.74-17.08 68.37-3.81-12.26-18.11-19.75-30.66-17.04-12.54 2.7-22.22 14.41-23.78 27.15-1.53 12.46 4.13 25.25 13.56 33.56.21.18.42.37.64.55z"
      ></path>
      <path
        fill="#fff"
        d="M800.405 604h2.83a2.06 2.06 0 00.63-.85c.16-.38.31-.77.48-1.15a345.304 345.304 0 01101.09-135.82 1.614 1.614 0 00.67-1.48 2.178 2.178 0 00-3.52-1.37 345.77 345.77 0 00-48.25 47.92 347.375 347.375 0 00-54.33 90.75c-.01.03-.02.05-.03.08a1.557 1.557 0 00.43 1.92z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M701.273 382.035a11.398 11.398 0 0111.386-11.386c.11 0 .218.006.327.013l35.208-28.064-25.231-25.232a11.13 11.13 0 1115.74-15.739l40.554 40.555-55.22 40.159a11.384 11.384 0 01-22.764-.306z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M659.944 590.049L648.037 585.604 659.517 537.561 677.09 544.122 659.944 590.049z"
      ></path>
      <path
        fill="#2f2e41"
        d="M640.29 578.836l23.476 8.764-5.398 14.459-37.422-13.971.19-.512a14.887 14.887 0 0119.154-8.74z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M767.066 590.229L754.356 590.229 748.31 541.205 767.069 541.206 767.066 590.229z"
      ></path>
      <path
        fill="#2f2e41"
        d="M744.731 586.597h25.059v15.434h-39.946v-.547a14.887 14.887 0 0114.887-14.887zM750.227 571.591a4.493 4.493 0 01-1.363-3.508c2.268-37.44-17.466-105.495-23.568-125.461a3.418 3.418 0 00-2.365-2.328 3.546 3.546 0 00-3.315.746c-32.962 28.712-42.799 109.716-44.436 125.663a4.494 4.494 0 01-5.034 3.998l-16.451-2.056a4.5 4.5 0 01-3.84-5.417l43.136-199.44.026-.121.078-.095c10.431-12.517 40.654-7.643 41.935-7.43l.133.022.104.087c38.81 32.184 36.843 181.366 36.055 210.944a4.5 4.5 0 01-4.071 4.353l-13.474 1.283q-.215.02-.43.02a4.488 4.488 0 01-3.12-1.26z"
      ></path>
      <circle cx="727.419" cy="251.287" r="24.561" fill="#ffb8b8"></circle>
      <path
        fill="#536dfe"
        d="M751.535 297.543s-22.807-26.955-41.468-5.184a74.113 74.113 0 00-17.81 50.433l.704 23.692 43.024-6.738z"
      ></path>
      <path
        fill="#2f2e41"
        d="M723.438 255.536l-10.553-12.432c-2.72-3.203-5.564-6.693-5.948-10.878-.422-4.587 2.368-9.046 6.183-11.628s8.498-3.555 13.091-3.912c8.518-.661 17.482.747 24.484 5.642s11.584 13.732 9.877 22.104c-1.345 6.592-6.299 12.906-4.373 19.352 2.107 7.053 10.747 9.217 17.8 11.32 11.841 3.53 23.147 10.48 29.352 21.165s6.178 25.416-2.093 34.594c-5.356 5.943-13.435 8.949-21.422 9.401s-15.939-1.429-23.514-4.002c-6.977-2.37-13.878-5.418-19.37-10.33s-9.45-11.939-9.279-19.305c.164-7.02 3.924-13.414 5.469-20.264a33.255 33.255 0 00-10.395-31.73"
      ></path>
      <path
        fill="#536dfe"
        d="M697.357 477.335H666.82a3.765 3.765 0 01-3.76-3.76v-36.037a3.765 3.765 0 013.76-3.76h30.537a3.765 3.765 0 013.761 3.76v36.036a3.765 3.765 0 01-3.76 3.76z"
      ></path>
      <path
        fill="#ffb8b8"
        d="M688.307 446.513a11.117 11.117 0 012.204-14.506l16.714-131.694a11.682 11.682 0 0111.566-10.192l.156.001a11.66 11.66 0 0111.32 13.733l-23.5 130.062.004.006a11.17 11.17 0 01-4.39 16.777 10.879 10.879 0 01-4.527.973 11.323 11.323 0 01-9.547-5.16z"
      ></path>
      <path
        fill="#3f3d56"
        d="M854.421 604h-257a1 1 0 010-2h257a1 1 0 110 2z"
      ></path>
    </svg>
    );
  }
}
